import {
  CLEAR_USER_INFO,
  COMMON_CONFIG,
  DEGREE_LIST,
  OCCUPATION_LIST,
  SET_ACTIVE_PLAN,
  SET_LANG,
  SUBSCRIPTION_PLAN,
  TOGGLE_APP_LOADER,
  UPDATE_COMMON_CONFIG,
  UPDATE_COUNTRIES_LIST,
  UPDATE_LOGIN_USER_INFO,
  UPDATE_SECONDARY_CONFIG,
  UPDATE_UNREAD_COUNT,
} from "./appConfig.constants";

const initialState = {
  userDetails: null,
  countriesList: [{ name: "India", id: "1", dialCode: "+91" }],
  appLoader: false,
  subscriptions: null,
  appConfig: null,
  occupationList: null,
  degreeList: null,
  activePlan: null,
  lang: null,
};

const AppConfigReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_LOGIN_USER_INFO:
      return {
        ...state,
        userDetails: {
          ...state.userDetails,
          ...action.value,
        },
      };
    case UPDATE_COUNTRIES_LIST:
      return {
        ...state,
        countriesList: action.value,
      };
    case CLEAR_USER_INFO:
      return initialState;
    case TOGGLE_APP_LOADER:
      return {
        ...state,
        appLoader: action.value,
      };
    case SUBSCRIPTION_PLAN:
      return {
        ...state,
        subscriptions: action.value,
      };
    case SET_ACTIVE_PLAN:
      return {
        ...state,
        activePlan: action.value,
      };
    case COMMON_CONFIG:
      return {
        ...state,
        appConfig: {
          ...state.appConfig,
          ...action.value,
        },
      };
    case UPDATE_COMMON_CONFIG:
      return {
        ...state,
        appConfig: {
          ...state.appConfig,
          ...action.value,
        },
      };
    case UPDATE_SECONDARY_CONFIG:
      return {
        ...state,
        appConfig: {
          ...state?.appConfig,
          secondaryConfig: {
            ...state?.appConfig?.secondaryConfig,
            ...action.value,
          },
        },
      };
    case OCCUPATION_LIST:
      return {
        ...state,
        occupationList: action.value,
      };
    case DEGREE_LIST:
      return {
        ...state,
        degreeList: action.value,
      };
    case UPDATE_UNREAD_COUNT:
      return {
        ...state,
        appConfig: JSON.parse(
          JSON.stringify({
            ...state.appConfig,
            unseenCounts: {
              ...state?.appConfig?.unseenCounts,
              ...action.value,
            },
          })
        ),
      };
    case SET_LANG:
      return {
        ...state,
        lang: action.value,
      };
    default:
      return state;
  }
};

export default AppConfigReducer;
